// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mainNei[data-v-6c9c071e]{overflow:hidden;margin-top:120px}.mainBox[data-v-6c9c071e]{padding-top:120px;flex-grow:1;flex-shrink:1}.layout[data-v-6c9c071e]{min-height:100vh;display:flex;flex-direction:column}", ""]);
// Exports
module.exports = exports;
